<template>
  <div class="all-title-wrapper">
    <!-- 失活的组件将会被缓存！-->
    <keep-alive>
      <component
        v-bind:is="currentComponentName"
        :name="titleName"
        :theme="titleTheme"
        :type="moduleType"
        :width="width"
      ></component>
    </keep-alive>
  </div>
</template>

<script>
import defaultTitle from "./titleDefault";
import stripTitle from "./titleStrip";
import tagTitle from "./titleTag";
import iconTitle from "./titleIcon";

export default {
  name: "EditorModuleTitle",
  props: {
    // 当前模块数据
    item: {
      type: Object,
      default: () => {},
    },
    // 当前模块坐标
    index: {
      type: Number,
      default: 0,
    },
    // 所有模块数据
    sPosition: {
      type: Array,
      default: () => [],
    },
    // 标题类型
    titleType: {
      type: String,
      default: "default",
    },
    // 标题名
    titleName: {
      type: String,
      default: "",
    },
    // 标题主题色
    titleTheme: {
      type: String,
      default: "#404040",
    },
    // 模块类型
    moduleType: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  components: {
    defaultTitle,
    stripTitle,
    tagTitle,
    iconTitle,
  },

  computed: {
    currentComponentName() {
      return `${this.titleType}Title`;
    },
  },
};
</script>

<style lang="scss" scoped>
.all-title-wrapper {
  position: relative;
  .title-operate-icon {
    display: none;
    position: absolute;
    top: 40%;
    right: 0;
    transform: translateY(-50%);
    &.left-form-icon {
      position: static;
      display: none;
      flex-direction: column;
      align-items: flex-end;
      transform: translateY(0);
      .icon-item {
        margin-right: 0;
        &:not(:last-child) {
          margin-bottom: 6px;
        }
      }
    }

    .icon-item {
      cursor: pointer;
      text-align: center;
      display: inline-block;
      width: 22px;
      height: 22px;
      background-color: #505667;
      color: #fff;
      border-radius: 4px;
      margin-right: 6px;
      text-align: center;
      font-size: 22px;
      line-height: 22px;
      &.sort-icon-prev {
        margin-right: 1px;
        border-radius: 4px 0 0 4px;
      }
      &.sort-icon-next {
        border-radius: 0 4px 4px 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .iconfont {
        font-size: 22px;
        line-height: 22px;
      }
      &:hover {
        background-color: #737885;
      }
      // 禁用
      &.disabled {
        background-color: #aeb2bd !important;
        cursor: not-allowed;
      }
    }
  }
}
</style>
